import React from 'react';
import { TableCell, TableHead, TableRow, TableSortLabel } from '@material-ui/core';
import { hanwahaInstance, jetStreamInstance } from '../../../shared/components';
const InventoryHd = ({sortInfo, createSortHandler}) => {
    return(
        <TableHead> 
            <TableRow>
                <TableCell rowSpan={hanwahaInstance ? 2 : 1}  style={{ position: 'sticky', left: 0, backgroundColor: '#B5BEDB', zIndex:15, width: '140px' }}>Action(s)</TableCell>
                <TableCell rowSpan={hanwahaInstance ? 2 : 1}>
                    <TableSortLabel
                        active={sortInfo.sort === 'description' ? true:false}
                        direction={sortInfo.sort === 'description' ? sortInfo.sort_by :'asc'}
                        onClick={()=>createSortHandler('description')}
                    >
                        Description
                    </TableSortLabel>
                </TableCell>
                {hanwahaInstance ?
                    <TableCell rowSpan={2}>Type</TableCell> : null
                }
                <TableCell rowSpan={hanwahaInstance ? 2 : 1}>
                    <TableSortLabel
                        active={sortInfo.sort === 'serial_number' ? true:false}
                        direction={sortInfo.sort === 'serial_number' ? sortInfo.sort_by :'asc'}
                        onClick={()=>createSortHandler('serial_number')}
                    >
                        Serial Number
                    </TableSortLabel>
                </TableCell>
                <TableCell rowSpan={hanwahaInstance ? 2 : 1}>
                    <TableSortLabel
                        active={sortInfo.sort === 'part_number' ? true:false}
                        direction={sortInfo.sort === 'part_number' ? sortInfo.sort_by :'asc'}
                        onClick={()=>createSortHandler('part_number')}
                    >
                        Part Number
                    </TableSortLabel>
                </TableCell>
                <TableCell rowSpan={hanwahaInstance ? 2 : 1}>
                    <TableSortLabel
                        active={sortInfo.sort === 'owner' ? true:false}
                        direction={sortInfo.sort === 'owner' ? sortInfo.sort_by :'asc'}
                        onClick={()=>createSortHandler('owner')}
                    >
                        {jetStreamInstance?"Owner/SPV":"Owner"}
                    </TableSortLabel>
                </TableCell>
                <TableCell rowSpan={hanwahaInstance ? 2 : 1}>
                    <TableSortLabel
                        active={sortInfo.sort === 'location' ? true:false}
                        direction={sortInfo.sort === 'location' ? sortInfo.sort_by :'asc'}
                        onClick={()=>createSortHandler('location')}
                    >
                        Location
                    </TableSortLabel>
                </TableCell>
                <TableCell rowSpan={hanwahaInstance ? 2 : 1}>
                    <TableSortLabel
                        active={sortInfo.sort === 'linked_asset' ? true:false}
                        direction={sortInfo.sort === 'linked_asset' ? sortInfo.sort_by :'asc'}
                        onClick={()=>createSortHandler('linked_asset')}
                    >
                        Linked Asset
                    </TableSortLabel>
                </TableCell>
                {hanwahaInstance ?
                    <TableCell rowSpan={2} >
                        <TableSortLabel
                        active={sortInfo.sort === 'reference' ? true:false}
                        direction={sortInfo.sort === 'reference' ? sortInfo.sort_by :'asc'}
                        onClick={()=>createSortHandler('reference')}
                    >
                        Reference
                    </TableSortLabel> </TableCell>:null
                }
                {hanwahaInstance ?
                    <TableCell colSpan={4} align="center">Asset Details</TableCell>
                    :
                    <TableCell>
                        <TableSortLabel
                            active={sortInfo.sort === 'status' ? true:false}
                            direction={sortInfo.sort === 'status' ? sortInfo.sort_by :'asc'}
                            onClick={()=>createSortHandler('status')}
                        >
                            Status
                        </TableSortLabel>
                    </TableCell>
                }
                {hanwahaInstance ?
                    <TableCell rowSpan={2}>Remarks</TableCell> : null
                }
            </TableRow>
            {hanwahaInstance ?
                <TableRow >
                    <TableCell>Seller</TableCell>
                    <TableCell>Lessee</TableCell>
                    <TableCell style={{maxWidth:'300px'}}>Location</TableCell>
                    <TableCell>Status</TableCell>
                </TableRow> : null
            }
        </TableHead>
    )
}
export default InventoryHd;